/* ZAAG New Arrivals Quick Buy: adds selected variant then proceeds to checkout. */
(function () {
  document.addEventListener('click', async function (event) {
    const button = event.target.closest('.zaag-quick-buy');
    if (!button || button.disabled) return;
    event.preventDefault();
    button.disabled = true;
    const original = button.textContent;
    button.textContent = 'Processing…';
    try {
      const response = await fetch(window.Shopify?.routes?.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: Number(button.dataset.variantId), quantity: 1 })
      });
      if (!response.ok) throw new Error((await response.json()).description || 'Unable to add item');
      if (window.ZaagMemberPricing) await window.ZaagMemberPricing.checkout();
      else throw new Error('Please refresh the page and try again.');
    } catch (error) {
      button.disabled = false;
      button.textContent = original;
      alert(error.message || 'Unable to proceed to checkout. Please try again.');
    }
  });
})();

